/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Whitelabel } from './Whitelabel';
export type AsafBoxUserUpdate = {
  name?: string;
  username?: string;
  password?: string;
  role?: AsafBoxUserUpdate.role;
  arboxUserId?: string;
  disabled?: boolean;
  priority?: number;
  whitelabels?: Array<Whitelabel>;
};
export namespace AsafBoxUserUpdate {
  export enum role {
    ADMIN = 'ADMIN',
    USER = 'USER',
  }
}

